<template>
    <ValidationProvider name="newsletterTermsboxValidation" rules="checkboxChecked" v-slot="{ errors }" slim>
        <div class="migrol-form__input-wrapper" :class="{ 'migrol-form__input-wrapper--error' : errors.length > 0 }">
            <div class="migrol-form__checkbox migrol-form__checkbox--checkbox">
                <input :id="$id('checkbox')" type="checkbox" v-model="innerValue" v-on="inputListeners">
                <label :for="$id('checkbox')">{{Strings['Forms.NewsletterSub.TermsCheckbox']}}*</label>
            </div>
            <div class="migrol-form__error-message">{{Strings['Forms.NewsletterSub.TermsError']}}</div>
        </div>
    </ValidationProvider>
</template>

<script>
    import { ValidationProvider } from 'VeeValidate';
    import { mapState } from 'vuex';

    export default {
        props: {
            value: {
                default: false
            }
        },
        data() {
            return {
                innerValue: ''
            }
        },
        computed: {
            ...mapState([
                'Strings'
            ]),
            inputListeners() {
                var vm = this
                // `Object.assign` merges objects together to form a new object
                return Object.assign({},
                    // We add all the listeners from the parent
                    this.$listeners,
                    // Then we can add custom listeners or override the
                    // behavior of some listeners.
                    {
                        // This ensures that the component works with v-model
                        input: function (event) {
                            vm.$emit('input', event.target.checked)
                        },
                        change: function (event) {
                            vm.$emit('change', event.target.checked)
                        }
                    }
                )
            }
        },
        watch: {
            value: {
                immediate: true,
                handler(newVal) {
                    this.innerValue = newVal;
                }
            }
        },
        components: {
            ValidationProvider
        }
    };
</script>